import { useAuth } from "../contexts/AuthContext";
import TrialExpiredBanner from "./TrialExpiredBanner";

/**
 * ✅ UPDATED: Read-Only Grace Period Approach
 *
 * OLD: Blocked expired users completely via SubscriptionGate
 * NEW: Allow read-only access with banner + action-level gates
 *
 * Benefits:
 * - Professional UX (not hostile)
 * - Higher conversion (users stay engaged)
 * - Data access (builds trust)
 * - Action-level blocking (clear upgrade prompts)
 */
export default function TeacherLayout({ children }) {
  const { userDoc } = useAuth();

  console.log('🏗️ TeacherLayout Debug:', {
    hasUserDoc: !!userDoc,
    plan: userDoc?.plan,
    status: userDoc?.status,
    isTesterAccount: userDoc?.isTesterAccount
  });

  return (
    <>
      {/* ✅ Show non-blocking banner for expired trials */}
      <TrialExpiredBanner />

      {/* ✅ Allow all teachers to view content (read-only for expired) */}
      {/* Action-level blocking happens in individual components */}
      {children}
    </>
  );
}